import React from "react";
import { Col, Row } from "react-bootstrap";
import chrome from "../../Assets/TechIcons/Google Chrome.svg";
import vsCode from "../../Assets/TechIcons/vscode.svg";
import pycharm from "../../Assets/TechIcons/pycharm.svg";
import fedora from "../../Assets/TechIcons/fedora.svg";
import ubuntu from "../../Assets/TechIcons/ubuntu.svg";
import firefox from "../../Assets/TechIcons/firefox.svg";


function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={chrome} alt="chrome" className="tech-icon-images" />
        <div className="tech-icons-text">Google Chrome</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={firefox} alt="firefox" className="tech-icon-images" />
        <div className="tech-icons-text">Firefox</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={vsCode} alt="vsCode" className="tech-icon-images" />
        <div className="tech-icons-text">Vs Code</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={pycharm} alt="pycharm" className="tech-icon-images" />
        <div className="tech-icons-text">Pycharm</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={fedora} alt="fedora" className="tech-icon-images" />
        <div className="tech-icons-text">Fedora</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={ubuntu} alt="ubuntu" className="tech-icon-images" />
        <div className="tech-icons-text">Ubuntu</div>
      </Col>

    </Row>
  );
}

export default Toolstack;
